import * as React from 'react'
import { Route } from 'react-router-dom'
import { SiteCountry } from '../data/models/locale'
import { urls } from '../urls'
import MemberRoute from './components/member_route'
import RedirectAdminRoute from './components/RedirectAdminRoute'
import { Sredirect } from './links'

const langs = Object.values(SiteCountry).join('|')
export const COUNTRY_PREFIX = `/:country_code(${langs})`

export function getCountryRoutes(requireAdminAuth: boolean) {
  const routes: JSX.Element[] = []
  // Build list of Route components based on urls.js

  for (const [name, link] of Object.entries(urls)) {
    for (const [country, url] of Object.entries(link.urls)) {
      let RouteComp

      if (requireAdminAuth && name !== 'admin') {
        RouteComp = RedirectAdminRoute
      } else if (link.auth) {
        RouteComp = MemberRoute
      } else {
        RouteComp = Route
      }

      const prefix = getCountryRegexString(country)
      routes.push(
        <RouteComp
          strict
          key={url}
          path={prefix + url}
          theme={link.theme}
          component={link.component as any}
          exact={true}
        />,
      )
      routes.push(
        <Route
          strict
          exact
          key={url + '/'}
          path={prefix + url + '/'}
          render={props => (
            <Sredirect name={name} params={props.match.params} />
          )}
          {...{ theme: link.theme }}
        />,
      )
    }
  }

  return routes
}

function getCountryRegexString(country: string) {
  let prefix = COUNTRY_PREFIX
  if (country !== 'default') {
    prefix = `/:country_code(${country})`
  }

  return prefix
}

export function getCountryRegex(country: string) {
  let prefix = COUNTRY_PREFIX
  if (country !== 'default') {
    prefix = `/:country_code(${country})`
  }

  prefix = prefix.replace('(', '\\((').replace(')', ')\\)')

  return new RegExp(prefix)
}
